import CharField from "components/MeForm/CharField";
import NumericField from "components/MeForm/NumericField";
import DropdownField from "components/MeForm/DropdownField";
import DateField from "components/MeForm/DateField";
import SubTable from "components/MeTable/SubTable";
import SelectionField from "components/MeForm/SelectionField";
import TextField from "components/MeForm/TextField";
import CheckboxField from "components/MeForm/CheckboxField";
import ButtonForm from "components/Buttons/ButtonForm";
import DatetimeField from "components/MeForm/DatetimeField";
import TimeField from "components/MeForm/TimeField";
import DividerField from "components/MeForm/Divider";
import CloudImage from "components/MeForm/CloudImage";
import MultiSelectionField from "components/MeForm/MultiSelectionField";
import ImageField from "components/MeForm/ImageField";
import ButtonModal from "components/Buttons/ButtonModal";
import SearchField from "components/MeForm/SearchField";
import RadioGroupField from "components/MeForm/RadioGroupField";
import TakeCapture from "components/MeForm/TakeCapture";
import FileField from "components/MeForm/FileField";
import IntegerField from "components/MeForm/IntegerField";
import ButtonCustomModal from "components/Buttons/ButtonCustomModal";
import ModalWizard from "components/Modals/ModalWizard";
import FloatField from "components/MeForm/FloatField";
import Paragraph from "components/MeForm/Paragraph";
import GridFields from "components/MeForm/GridFields";
import CustomWidget from "components/MeForm/CustomWidget";
import CustomButtonWidget from "components/MeForm/CustomButtonWidget";
import Heading from "components/MeForm/Heading";
import DateCalendarV1 from "components/MeForm/DateCalendarV1";
import Tabs from "components/Tabs/Tabs";
import GridCards from "components/Card/GridCardsNew";
import ButtonCheck from "components/Buttons/ButtonCheck";

const pool = {
  char: CharField,
  numeric: NumericField,
  selection: SelectionField,
  text: TextField,
  date: DateField,
  datetime: DatetimeField,
  time: TimeField,
  one2many: SubTable,
  multiselection: MultiSelectionField,
  integer: IntegerField,
  float: FloatField,
  boolean: CheckboxField,
  many2one: DropdownField,
  search_add: SearchField,
  search_add_new: SearchField,
  radio: RadioGroupField,
  button: ButtonForm,
  image: ImageField,
  button_wizard: ModalWizard,
  cloud_image: CloudImage,
  button_modal: ButtonModal,
  take_capture: TakeCapture,
  file: FileField,
  divider: DividerField,
  button_custom_modal: ButtonCustomModal,
  paragraph: Paragraph,
  grid: GridFields,
  custom: CustomWidget,
  custom_button: CustomButtonWidget,
  heading: Heading,
  tabs: Tabs,
  cards: GridCards,
  date_v2: DateCalendarV1,
  button_check: ButtonCheck,
};

export default pool;
